import { isSameDay } from 'date-fns'
export type DateRange = {
  key: string
  startDate: Date
  endDate: Date
}

export const staticRanges = (ranges: DateRange[]) => {
  return Object.values(ranges).map(r => ({
    label: r.key,

    isSelected(range) {
      const definedRange = this.range()
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      )
    },

    range: () => ({
      startDate: r.startDate,
      endDate: r.endDate,
    }),
  }))
}
